<cc-nav-on-product
    [casinoProduct]="product"
    [categoryRoute]="routeCategoryType"
    [stickyInputQueryElement]="'cs-games-nav-section'"></cc-nav-on-product>
